<template>
  <div class="status-view text-center w-full mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-center">
      <div class="w-full">
        <img
          :src="image"
          alt="Status image"
          class="h-72 w-auto mx-auto mb-2"
        >
        <h2 class="text-2xl font-bold text-white">
          {{ $t(title) }}
        </h2>
        <p
          class="text-white"
          v-html="$t(description)"
        />
        <button
          v-if="retryUrl"
          type="button"
          data-test-id="retry-btn"
          class="mt-6 px-6 py-2 rounded-lg bg-white text-gray-900 font-semibold"
          @click="retry"
        >
          {{ $t('connectionError.retry') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useDynamicFormStore } from '@/store/dynamicFormStore'
import soldOutDark from '@/assets/sold-out-dark.svg'
import soldOutLight from '@/assets/sold-out-light.svg'
import dark404 from '@/assets/404-dark.svg'
import light404 from '@/assets/404-light.svg'

export default {
  name: 'StatusView',
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(useDynamicFormStore, { dynamicFormTemplate: 'dataUser' }),
    image({ dynamicFormTemplate, type }) {
      if (['soldOut', 'closed'].includes(type)) {
        return Object.keys(dynamicFormTemplate).length && !dynamicFormTemplate?.isDark ? soldOutDark : soldOutLight
      }
      return light404
    },
    // Only same-app inscription paths: the redirect comes from the URL, so anything
    // else (other hosts, protocol-relative, backslash tricks) would be an open redirect.
    retryUrl({ type, $route }) {
      if (type !== 'connectionError') return null
      const redirect = $route.query?.redirect
      return typeof redirect === 'string' && /^\/inscription\/[^/\\]/.test(redirect) ? redirect : null
    },
  },
  methods: {
    retry() {
      window.location.assign(this.retryUrl)
    },
  },
}
</script>
